<div class="mobile">
    <mat-toolbar>
        <a class="home" routerLink="/">
            <img src="assets/icons/logo.png" />
        </a>
        <span class="spacer"></span>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>menu</mat-icon>
        </button>
    </mat-toolbar>
    <mat-menu #menu="matMenu">
        @if (!hosted) {
            <a mat-menu-item routerLink="/pricing">Pricing</a>
        }
        <button mat-menu-item (click)="login(false)">Log in</button>
        @if (!hosted) {
            <button mat-menu-item color="primary" (click)="login(true)">Sign up</button>
        }
        @if (user$ | async) {
            <button mat-button (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        }
    </mat-menu>
</div>

<div class="desktop">
    <mat-toolbar>
        <a class="home" routerLink="/">
            <img src="assets/icons/logo.png" />
        </a>
        @if (!hosted) {
            <a mat-button routerLink="/pricing">Pricing</a>
        }
        <span class="spacer"></span>
        @if (user$ | async; as user) {
            <button mat-button (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        } @else {
            <button mat-button (click)="login(false)">Log in</button>
            @if (!hosted) {
                <button mat-flat-button color="primary" (click)="login(true)">Sign up</button>
            }
        }
    </mat-toolbar>
</div>
